var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.content,
    classes: _vm.css(''),
    trigger: _vm.setTrigger,
    placement: _vm.position,
  }),expression:"{\n    content,\n    classes: css(''),\n    trigger: setTrigger,\n    placement: position,\n  }"}]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }